(function () {
  if (window.__mtBase) return; window.__mtBase = true;
  var COLORES = { 'gris': '#9EA3A8', 'negro': '#2B2B2E', 'verde': '#2F7D6E', 'azul marino': '#2E3F6E', 'morado': '#6B3F7A' };
  function bolitas(raiz) {
    (raiz || document).querySelectorAll('.mt-prod__color').forEach(function (b) {
      var c = COLORES[(b.dataset.titulo || '').trim().toLowerCase()];
      if (c) b.style.setProperty('--bolita', c);
    });
  }
  function iniciar(raiz) {
    bolitas(raiz);
    var els = (raiz || document).querySelectorAll('.mt-aparece:not(.mt-visible)');
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
      els.forEach(function (e) { e.classList.add('mt-visible'); }); return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('mt-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState !== 'loading') iniciar(); else document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
